(function () {
  'use strict';

  // Mobile only
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  const style = document.createElement('style');
  style.textContent = `
    .ss-mobile-zoom {
      position: fixed;
      inset: 0;
      z-index: 999999;
      display: none;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.96);
      touch-action: none;
      overscroll-behavior: contain;
    }

    .ss-mobile-zoom.is-open {
      display: block;
    }

    .ss-mobile-zoom__stage {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      touch-action: none;
    }

    .ss-mobile-zoom__image {
      display: block;
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      user-select: none;
      -webkit-user-select: none;
      -webkit-user-drag: none;
      transform-origin: center center;
      will-change: transform;
      touch-action: none;
      cursor: grab;
    }

    .ss-mobile-zoom__close {
      position: absolute;
      top: max(14px, env(safe-area-inset-top));
      right: 14px;
      z-index: 3;
      width: 48px;
      height: 48px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.95);
      color: #111;
      font-size: 34px;
      font-family: Arial, sans-serif;
      font-weight: 300;
      line-height: 46px;
      text-align: center;
      cursor: pointer;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
    }

    .ss-mobile-zoom__hint {
      position: absolute;
      bottom: max(22px, env(safe-area-inset-bottom));
      left: 50%;
      z-index: 2;
      transform: translateX(-50%);
      padding: 7px 12px;
      border-radius: 20px;
      background: rgba(0, 0, 0, 0.65);
      color: #fff;
      font: 13px/1.2 Arial, sans-serif;
      white-space: nowrap;
      pointer-events: none;
      transition: opacity 0.25s ease;
    }

    .ss-mobile-zoom__hint.is-hidden {
      opacity: 0;
    }

    body.ss-mobile-zoom-open {
      overflow: hidden !important;
      position: fixed;
      width: 100%;
    }
  `;
  document.head.appendChild(style);

  const viewer = document.createElement('div');
  viewer.className = 'ss-mobile-zoom';
  viewer.setAttribute('role', 'dialog');
  viewer.setAttribute('aria-modal', 'true');
  viewer.setAttribute('aria-label', 'Product image viewer');

  viewer.innerHTML = `
    <button
      type="button"
      class="ss-mobile-zoom__close"
      aria-label="Close image"
    >&times;</button>

    <div class="ss-mobile-zoom__stage">
      <img class="ss-mobile-zoom__image" alt="">
    </div>

    <div class="ss-mobile-zoom__hint">
      Pinch or double-tap to zoom
    </div>
  `;

  document.body.appendChild(viewer);

  const stage = viewer.querySelector('.ss-mobile-zoom__stage');
  const zoomImage = viewer.querySelector('.ss-mobile-zoom__image');
  const closeButton = viewer.querySelector('.ss-mobile-zoom__close');
  const hint = viewer.querySelector('.ss-mobile-zoom__hint');

  const pointers = new Map();

  let scale = 1;
  let translateX = 0;
  let translateY = 0;

  let startScale = 1;
  let startTranslateX = 0;
  let startTranslateY = 0;

  let pinchStartDistance = 0;
  let pinchStartCenter = null;
  let dragStart = null;

  let lastTapTime = 0;
  let savedScrollY = 0;

  function getHighResolutionSource(image) {
    const master = image.getAttribute('data-master');

    if (master) {
      return master
        .replace('{width}', '2400')
        .replace(/_1x1\./, '_2400x.');
    }

    return image.currentSrc || image.src;
  }

  function applyTransform(animate) {
    zoomImage.style.transition = animate
      ? 'transform 220ms ease'
      : 'none';

    zoomImage.style.transform =
      `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;
  }

  function limitTranslation() {
    if (scale <= 1) {
      translateX = 0;
      translateY = 0;
      return;
    }

    const imageRect = zoomImage.getBoundingClientRect();
    const stageRect = stage.getBoundingClientRect();

    const scaledWidth = imageRect.width;
    const scaledHeight = imageRect.height;

    const maxX = Math.max(0, (scaledWidth - stageRect.width) / 2);
    const maxY = Math.max(0, (scaledHeight - stageRect.height) / 2);

    translateX = Math.max(-maxX, Math.min(maxX, translateX));
    translateY = Math.max(-maxY, Math.min(maxY, translateY));
  }

  function resetZoom(animate) {
    scale = 1;
    translateX = 0;
    translateY = 0;
    applyTransform(animate);
  }

  function openViewer(sourceImage) {
    savedScrollY = window.scrollY;

    zoomImage.src = getHighResolutionSource(sourceImage);
    zoomImage.alt = sourceImage.alt || '';

    viewer.classList.add('is-open');
    document.body.classList.add('ss-mobile-zoom-open');
    document.body.style.top = `-${savedScrollY}px`;

    hint.classList.remove('is-hidden');
    resetZoom(false);

    window.setTimeout(function () {
      hint.classList.add('is-hidden');
    }, 1800);
  }

  function closeViewer() {
    viewer.classList.remove('is-open');

    document.body.classList.remove('ss-mobile-zoom-open');
    document.body.style.top = '';

    window.scrollTo(0, savedScrollY);

    pointers.clear();
    resetZoom(false);

    zoomImage.removeAttribute('src');
  }

  function getDistance(pointA, pointB) {
    return Math.hypot(
      pointB.x - pointA.x,
      pointB.y - pointA.y
    );
  }

  function getCenter(pointA, pointB) {
    return {
      x: (pointA.x + pointB.x) / 2,
      y: (pointA.y + pointB.y) / 2
    };
  }

  document.addEventListener('click', function (event) {
    const image = event.target.closest(
      '[data-js-product-gallery-main-item] img'
    );

    if (!image) return;
    if (viewer.contains(image)) return;

    event.preventDefault();
    event.stopPropagation();

    openViewer(image);
  }, true);

  closeButton.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    closeViewer();
  });

  viewer.addEventListener('click', function (event) {
    if (event.target === viewer || event.target === stage) {
      if (scale === 1) closeViewer();
    }
  });

  stage.addEventListener('pointerdown', function (event) {
    event.preventDefault();

    stage.setPointerCapture(event.pointerId);

    pointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY
    });

    zoomImage.style.transition = 'none';

    if (pointers.size === 1) {
      dragStart = {
        x: event.clientX,
        y: event.clientY
      };

      startTranslateX = translateX;
      startTranslateY = translateY;
    }

    if (pointers.size === 2) {
      const points = Array.from(pointers.values());

      pinchStartDistance = getDistance(points[0], points[1]);
      pinchStartCenter = getCenter(points[0], points[1]);

      startScale = scale;
      startTranslateX = translateX;
      startTranslateY = translateY;
    }
  });

  stage.addEventListener('pointermove', function (event) {
    if (!pointers.has(event.pointerId)) return;

    event.preventDefault();

    pointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY
    });

    if (pointers.size === 2) {
      const points = Array.from(pointers.values());
      const currentDistance = getDistance(points[0], points[1]);
      const currentCenter = getCenter(points[0], points[1]);

      scale = Math.max(
        1,
        Math.min(5, startScale * (currentDistance / pinchStartDistance))
      );

      translateX =
        startTranslateX + (currentCenter.x - pinchStartCenter.x);

      translateY =
        startTranslateY + (currentCenter.y - pinchStartCenter.y);

      applyTransform(false);
      return;
    }

    if (pointers.size === 1 && scale > 1 && dragStart) {
      translateX =
        startTranslateX + (event.clientX - dragStart.x);

      translateY =
        startTranslateY + (event.clientY - dragStart.y);

      applyTransform(false);
    }
  });

  function finishPointer(event) {
    pointers.delete(event.pointerId);

    if (pointers.size === 0) {
      limitTranslation();
      applyTransform(true);
      dragStart = null;
    }

    if (pointers.size === 1) {
      const remainingPoint = Array.from(pointers.values())[0];

      dragStart = {
        x: remainingPoint.x,
        y: remainingPoint.y
      };

      startTranslateX = translateX;
      startTranslateY = translateY;
    }
  }

  stage.addEventListener('pointerup', finishPointer);
  stage.addEventListener('pointercancel', finishPointer);

  stage.addEventListener('dblclick', function (event) {
    event.preventDefault();

    if (scale > 1) {
      resetZoom(true);
    } else {
      scale = 2.5;
      translateX = 0;
      translateY = 0;
      applyTransform(true);
    }
  });

  stage.addEventListener('touchend', function (event) {
    if (event.changedTouches.length !== 1) return;

    const now = Date.now();

    if (now - lastTapTime < 300) {
      event.preventDefault();

      if (scale > 1) {
        resetZoom(true);
      } else {
        scale = 2.5;
        translateX = 0;
        translateY = 0;
        applyTransform(true);
      }

      lastTapTime = 0;
    } else {
      lastTapTime = now;
    }
  }, { passive: false });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && viewer.classList.contains('is-open')) {
      closeViewer();
    }
  });
})();